<div class="modal-header">
  <div>
    <h4 class="modal-title">{{ 'SALES.SALES_REQUESTS_FORM.GUEST_NAMES_DETAILS' | translate }}</h4>
    <div class="request-reference">
      {{ 'SALES.SALES_REQUESTS_FORM.REQUEST_LINE' | translate }} #{{ requestNumber }}
    </div>
  </div>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
  ></button>
</div>

<div class="modal-body">
  <div class="request-summary table-responsive">
    <table class="table table-bordered request-summary-table">
      <thead>
      <tr>
        <th class="summary-date-column">
          {{ 'SALES.SALES_REQUESTS_FORM.CHECK_IN' | translate }}
        </th>
        <th class="summary-date-column">
          {{ 'SALES.SALES_REQUESTS_FORM.CHECK_OUT' | translate }}
        </th>
        <th class="summary-type-column">
          {{ 'SALES.SALES_REQUESTS_FORM.TYPE' | translate }}
        </th>
        <th class="summary-number-column">
          {{ 'SALES.SALES_REQUESTS_FORM.PEOPLE' | translate }}
        </th>
        <th class="summary-number-column">
          {{ 'SALES.SALES_REQUESTS_FORM.ROOM_COUNT' | translate }}
        </th>
        <th class="summary-standard-column">
          {{ 'SALES.SALES_REQUESTS_FORM.MEAL_PLAN' | translate }}
        </th>
        <th class="summary-standard-column">
          {{ 'SALES.SALES_REQUESTS_FORM.HOTEL_STARS' | translate }}
        </th>
        <th class="summary-hotel-column">
          {{ 'SALES.SALES_REQUESTS_FORM.HOTEL' | translate }}
        </th>
        <th class="summary-budget-column">
          {{ 'SALES.SALES_REQUESTS_FORM.BUDGET' | translate }}
        </th>
        <th class="summary-note-column">
          {{ 'SALES.SALES_REQUESTS_FORM.NOTE' | translate }}
        </th>
        <th class="summary-status-column">
          {{ 'SALES.SALES_REQUESTS_FORM.STATUS' | translate }}
        </th>
      </tr>
      </thead>

      <tbody>
      <tr>
        <td>{{ checkIn }}</td>
        <td>{{ checkOut }}</td>
        <td>{{ typeLabel }}</td>
        <td>{{ request?.people || '—' }}</td>
        <td>{{ request?.count || '—' }}</td>
        <td>{{ mealPlanLabel }}</td>
        <td>{{ hotelStarsLabel }}</td>
        <td [title]="hotelLabel">{{ hotelLabel }}</td>
        <td [title]="budgetLabel">{{ budgetLabel }}</td>
        <td
          class="summary-note-value"
          [title]="request?.note || ''"
        >
          {{ request?.note || '—' }}
        </td>
        <td>{{ statusLabel }}</td>
      </tr>
      </tbody>
    </table>
  </div>

  <form [formGroup]="form" class="nightly-form">
    <div class="table-responsive nightly-table-holder">
      <table class="table table-bordered nightly-table">
        <thead>
        <tr>
          <th class="number-column">№</th>
          <th class="date-column">
            {{ 'SALES.SALES_REQUESTS_FORM.DATE' | translate }}
          </th>
          <th>
            {{ 'SALES.SALES_REQUESTS_FORM.GUEST_NAMES' | translate }}
          </th>
        </tr>
        </thead>

        <tbody formArrayName="nights">
        <tr
          *ngFor="let night of nights.controls; let I = index"
          [formGroupName]="I"
        >
          <td class="number-column">{{ I + 1 }}</td>
          <td class="date-column">
            {{ night.get('date')?.value | date : 'dd.MM.yyyy' }}
          </td>

          <td>
            <div
              class="night-guest-names"
              formArrayName="guest_names"
            >
              <div
                class="guest-name-control"
                *ngFor="let guestName of getGuestNames(night).controls; let J = index"
              >
                <div class="guest-name-label">
                  Guest {{ J + 1 }}
                  <span>
                      [{{ night.get('date')?.value | date : 'dd.MM.yyyy' }}]
                    </span>
                </div>

                <input
                  type="text"
                  class="form-control"
                  [formControlName]="J"
                />
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div
      *ngIf="nights.length === 0"
      class="alert alert-warning mb-0"
    >
      {{ 'SALES.SALES_REQUESTS_FORM.NO_NIGHTS' | translate }}
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-light"
    (click)="modal.dismiss('Cancel')"
  >
    {{ 'CANCEL' | translate }}
  </button>

  <button
    type="button"
    class="btn btn-primary"
    [disabled]="nights.length === 0 || guestNamesCount === 0"
    (click)="save()"
  >
    {{ 'SALES.SALES_REQUESTS_FORM.SAVE' | translate }}
  </button>
</div>
